import { render, staticRenderFns } from "./PaymentNewOptionsMoreDialog.vue?vue&type=template&id=2085f68f&scoped=true"
import script from "./PaymentNewOptionsMoreDialog.vue?vue&type=script&lang=ts"
export * from "./PaymentNewOptionsMoreDialog.vue?vue&type=script&lang=ts"
import style0 from "./PaymentNewOptionsMoreDialog.vue?vue&type=style&index=0&id=2085f68f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2085f68f",
  null
  
)

export default component.exports